var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ dashboard__data: !_vm.report }},[(_vm.report)?[_vm._v(" Популярные точки: "+_vm._s(_vm.countMobileUsers)+" ")]:[_c('app-dashboard-num',{attrs:{"number":_vm.countMobileUsers,"today":_vm.countTodayMobileUsers}}),_c('app-dashboard-diagram',{attrs:{"data":_vm.mobileUsers}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }